//提携先企業（partners）の参照許可設定component
import React, {Component} from 'react';
import Modal from 'react-modal';
import * as firebase from "firebase";

//提携先データサンプル取得
import {
	getPartnersData
} from '../datas/partners'


export default class Permission extends Component {

	constructor(props) {
		super(props)
		this.state = {
			partners:{},
			service_name : {},//キーは提携企業テーブルのユニークID、バリューは、提携企業テーブルの企業名（サイト名）
			permissionState: {},//ユーザーが保持している制限設定情報
			showModal:false,
			service_data_in_modal:'',//モーダルに渡す企業ID
			isSetPermissoin:false,//制限設定情報をセット済みか否かのフラグ

		}
	}

	componentWillMount = () => {
		this.getPartners()
	}

	componentWillReceiveProps = (state) => {
		const {
			isSetPermissoin,
		} = this.state

		//ユーザーの制限設定情報セット※一回だけ　初期以降はstateでON/OFF表示
		if(!isSetPermissoin) {
			this.setPermissionState(state.permissionState)
			this.setState({isSetPermissoin:true})
		}
	}
	//ユーザーの制限設定情報セット※一回だけ　初期以降はstateでON/OFF表示
	setPermissionState = (permissionState) => {
		//console.log('SET!',permissionState)
		this.setState({
			permissionState: permissionState ? JSON.parse(JSON.stringify(permissionState)) : {}
		})
	}
	//提携企業一覧取得
	getPartners = async () => {
		let partners = await getPartnersData()
		//console.log(partners)
		this.setState({partners: JSON.parse(partners)},() => {
			this.setPartners()
		})
	}
	setPartners = () => {
		const {
			partners
		} = this.state
		let service_name = {}

		Object.keys(partners).forEach((key) => {
			let partner = partners[key]
			if(partner.site_name && partner.uid) {
				service_name[partner.uid] = partner.site_name
			}
		})
		this.setState({service_name:{...service_name}})
	}
	//MyRate情報参照の許可一覧レンダリング
	showPermission = () => {
		const {
			service_name
		} = this.state

		let ret = []

		Object.keys(service_name).forEach((key) => {
			let list = (
				<li key={key}>
					<div className="service-name">{service_name[key]}</div>
					{ this.renderingSwitch(key) }
				</li>
			)
			ret.push(list)
		})

		return (
			<ul className="permission-list">
				{ret}
			</ul>
		)
	}

	//制限情報DB格納
	setPermissionToDB = (permissionState) => {
		const {
			uid
		} = this.props
		firebase.database().ref('users/' + uid + '/permissions').set(permissionState)
		//console.log(permissionState)
		this.setState({permissionState:permissionState})		
	}

	//スイッチonClick
	setPermission = (e) => {
		const {
			permissionState
		} = this.state
		let data = e.currentTarget.dataset.name
		let status = e.currentTarget.dataset.status
		//console.log(data,status)

		let copyPermissionState = JSON.parse(JSON.stringify(permissionState))
		if(status === 'approved') {
			copyPermissionState[data] = 'denied'
			//DB格納！
			this.setPermissionToDB(copyPermissionState)					
		} else {
			//popup!
			this.showModal(data)		
		}
	}

	showModal = (data) => {
		this.setState({showModal:true})
		if(data) {
			this.setState({service_data_in_modal:data})
		}
	}

	closeModal = (e) => {
		if(e) e.preventDefault()
		this.setState({showModal:false})
	}
	//許可(OK)onClick
	approved = (e) => {
		e.preventDefault()
		const {
			service_data_in_modal,
			permissionState
		} = this.state
		let copyPermissionState = JSON.parse(JSON.stringify(permissionState))
		copyPermissionState[service_data_in_modal] = 'approved'
		this.closeModal()
		//DB格納！
		this.setPermissionToDB(copyPermissionState)					
	}

	//modalレンダリング
	modals = () => {
		let customStyles = {
			content: {
				maxWidth:'400px',
				margin:'auto',
				borderRadius:'10px',
				bottom:'auto'
			},
			overlay: {
				background:'rgba(0, 0, 0, 0.5)'
			}
		}

		const {
			showModal,
			service_data_in_modal,
			service_name
		} = this.state
		//TODO 20180531本番リリース済みだが文言修正の可能性あり
		return (
			<Modal
				isOpen={showModal}
				onRequestClose={this.closeModal}
				ariaHideApp={false}
				style={customStyles}
			>
			    <div className="modal-close" onClick={this.closeModal}></div>
				<div className="permission-modal">
					<p className="title">MyRate情報参照の許可</p>
					<p>{service_name[service_data_in_modal]}に対して、あなたのMyRate情報の参照を許可します。参照される情報は以下のとおりです。</p>
					<ul>
						<li>・あなたの名前</li>
						<li>・MyRate上でのあなたの評価</li>
						<li>・あなたがMyRateに連携している全サービスの利用実績サマリ</li>
					</ul>
					<p>{service_name[service_data_in_modal]}が上記の情報を参照することで、あなたの信用度に応じたサービスを受けられる場合があります。</p>
					<div className="btn-chans">
						<a className="btn-chan" href="" onClick={this.closeModal}>キャンセル</a>
						<a className="btn-chan submit" href="" onClick={this.approved}>はい</a>
					</div>
				</div>
			</Modal>
		)
	}
	//スイッチレンダリング
	renderingSwitch = (value) => {
		const {
			permissionState
		} = this.state

		let isActive = permissionState[value] && permissionState[value] === 'approved' ? ' is-active' : ''
		return (
			<div
				className={`switch-wrapper${isActive}`}
				data-name={value}
				data-status={permissionState[value]}
				onClick={this.setPermission}
			>
				<div className="switch" />
			</div>
		)
	}

	render () {
		const {
			service_name
		} = this.state
		//提携企業が一件もない場合はこのコンポーネントは表示しない
		if(Object.keys(service_name).length <= 0) {
			return null
		}
		return (
			<div>
				<hr className="border-gray" />
				<div className="block-permission">
					<h2 className="subtitle">MyRate情報参照の許可</h2>
					<p className="text-s">MyRateと提携している企業に対し、あなたのMyRate情報の参照を許可します。提携先企業があなたのMyRate情報を参照することで、あなたの信用度に応じたサービスを提携企業から受けられる場合があります。（提携先企業によってサービスの内容は異なります）</p>
					{ this.showPermission() }
				</div>
				{this.modals()}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/permission.js